// ADR-198: Reports → Scheduled Jobs (read-only).
import { SUBJECTS, ACTIONS } from './permissions';
import { INGESTION_SYNC_RUNS_PATH } from './ingestionSyncRuns';
import { INTEGRITY_CHECKS_PATH } from './integrityChecks';

export const SCHEDULED_JOBS_PATH = '/reports/scheduled-jobs';

/** How often the page refreshes itself while open. */
export const SCHEDULED_JOBS_REFRESH_MS = 60 * 1000;

export const JOB_STATES = {
  SCHEDULED: 'SCHEDULED',
  RUNNING: 'RUNNING',
  MANUAL_ONLY: 'MANUAL_ONLY',
  STOPPED: 'STOPPED',
};

export const JOB_STATE_LABELS = {
  SCHEDULED: 'Scheduled',
  RUNNING: 'Running',
  MANUAL_ONLY: 'Manual only',
  STOPPED: 'Stopped',
};

export const JOB_STATE_COLORS = {
  SCHEDULED: 'success',
  RUNNING: 'info',
  MANUAL_ONLY: 'default',
  STOPPED: 'warning',
};

export const JOB_OUTCOME_LABELS = {
  SUCCEEDED: 'Succeeded',
  FAILED: 'Failed',
};

export const JOB_OUTCOME_COLORS = {
  SUCCEEDED: 'success',
  FAILED: 'error',
};

export const JOB_CATEGORY_LABELS = {
  INGESTION: 'Ingestion',
  EMPLOYMENT_LIFECYCLE: 'Employment lifecycle',
  AUDIT_INTEGRITY: 'Audits & integrity',
  FEEDBACK: 'Feedback',
  HOUSEKEEPING: 'Housekeeping',
  UNCATEGORIZED: 'Other',
};

/**
 * Where a job's persisted runs live (radar-scheduler catalog `runHistory.report`).
 * Shown as a link only when the viewer can read that report.
 */
export const RUN_HISTORY_REPORTS = {
  INGESTION_SYNC_RUNS: {
    label: 'Ingestion Sync Runs',
    path: INGESTION_SYNC_RUNS_PATH,
    action: ACTIONS.READ,
    subject: SUBJECTS.INGESTION_SYNC_RUN,
  },
  DIRECT_MANAGER_DISCREPANCIES: {
    label: 'Discrepancy Audit runs',
    path: '/reports/direct-manager-discrepancies/runs',
    action: ACTIONS.READ,
    subject: SUBJECTS.DIRECT_MANAGER_DISCREPANCY,
  },
  BENCH_CANDIDATES: {
    label: 'Bench Candidates',
    path: '/reports/bench-candidates',
    action: ACTIONS.READ,
    subject: SUBJECTS.BENCH_CANDIDATE,
  },
  // ADR-199: live results, not stored runs. Linked only while the report's
  // feature flag is on (constants/featureFlags.js).
  INTEGRITY_CHECKS: {
    featureFlag: 'INTEGRITY_CHECKS_REPORT',
    label: 'Integrity Checks',
    path: INTEGRITY_CHECKS_PATH,
    action: ACTIONS.READ,
    subject: SUBJECTS.EMPLOYMENT_CHANGE_RECORD,
  },
};
